import { Typography } from 'antd'
import { DirtyHeaderProps } from './types'

const DirtyHeader: React.VFC<DirtyHeaderProps> = ({ title, isDirty }) =>
  isDirty ? (
    <>
      {title} -{' '}
      <Typography.Text type="warning">*unsaved changes</Typography.Text>
    </>
  ) : (
    <>{title}</>
  )

export default DirtyHeader
